import { Experiment, User } from '@ms/yammer-data/dist/state/types';
import {
  useAndReportExperimentTreatment,
  useExperimentTreatmentWithoutReporting,
} from '@ms/yammer-hooks/dist/experiments';
import { useViewerCanAccessUserStoryline } from '@ms/yammer-hooks/dist/userHeaders';
import { useCanCurrentUserAccessStoryline } from '@ms/yammer-hooks/dist/userProfile';
import { useFindUser, useIsExternal } from '@ms/yammer-hooks/dist/users';

import { UseUIFeatureCheck } from '../types';

export { useCanCurrentUserAccessStorylineHome } from '@ms/yammer-hooks/dist/storylineHome';
export { useCanCurrentUserAccessStoryline };

// This hook is a copy of @ms/yammer-hooks/dist/userProfile -> useCanUserAccessStoryline.
// The key difference is it won't throw in case the user object cannot be found, allowing the hook to be called while user data is still being fetched.
export const useCanUserAccessStoryline: UseUIFeatureCheck<[userId: User['id']]> = (userId) => {
  const canCurrentUserAccessStoryline = useCanCurrentUserAccessStoryline();
  const canViewerAccessUserStoryline = useViewerCanAccessUserStoryline(userId);
  const isExternalUser = useIsExternal(userId);
  const user = useFindUser(userId);
  const isStorylinePerUserControlEnabled =
    useAndReportExperimentTreatment(Experiment.StorylinePerUserControl) === 'enabled';

  if (!user) {
    return false;
  }

  if (isStorylinePerUserControlEnabled) {
    return canViewerAccessUserStoryline;
  }

  return canCurrentUserAccessStoryline && !user.isGuest && !isExternalUser;
};

export const useIsStorylineDraftPostEnabled: UseUIFeatureCheck = () =>
  useExperimentTreatmentWithoutReporting(Experiment.DraftPostStoryline) === true;
